<template>
  <div class="text-input">
    <ValidationProvider
      v-slot="{ errors }"
      :name="label"
      :rules="validationRules"
    >
      <div
        class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
      >
        <div class="vs-con-input">
          <label
            v-if="label || required"
            :for="`input-${name}`"
            class="vs-input--label"
            >{{ label }}
            <span v-if="required" class="text-danger"
              ><feather-icon icon="star-of-life"/></span
          ></label>
          <vs-input-number
            v-model="internalValue"
            :placeholder="placeholder"
            :name="name"
            v-bind="$attrs"
            icon-pack="fas"
            icon-inc="fa-plus"
            icon-dec="fa-minus"
            class="data-input"
            :class="{ error: errors.length }"
          />
        </div>
      </div>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, default: null },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    name: { type: String, required: true },
    required: { type: Boolean, default: false }
  },
  computed: {
    internalValue: {
      get() {
        return this.value || 0;
      },
      set(value) {
        this.$emit("input", +value);
      }
    }
  }
};
</script>
